import moment from 'moment'
// import { isObjectType } from 'graphql'
import { TenderFile } from '@/types/commonFile.js'

import { mapGetters } from 'vuex'
import SmarttenderApi from '@/api/smarttenderApi'
const st_api = new SmarttenderApi()
import SignyApi from '@/api/signyApi'
const signy_api = new SignyApi()


import SuppliersApi from '@/api/suppliersApi'
const suppliers_api = new SuppliersApi()

import { datePickerMixin } from './index'
import storageMixin from './storageMixin'
import debounce from 'lodash/debounce'

export default {
  mixins: [ datePickerMixin, storageMixin ],
  data() {
    return {
      crmSupplierVerificationByTender: [],
      crmSupplierVerificationByTenderLoaded: false
    }
  },
  computed: {
    ...mapGetters({
      settings: 'getSettings',
      $_stageAgreements: 'getStageAgreements',
    }),
    $_isGroupEnabled() {
      return this.$can('show', 'useGroupLots') && this.tender?.biddingType?.groupedLotsEnabled
    },
    has_required_agreement() {
      let statuses = this.settings?.tenderSettings?.tenderAgreeStatus,
        tender = this.tender || this.item || this.options?.tender,
        stat = tender?.tenderStatusId || tender?.tenderStatus?.id
      return statuses?.find(item => item.tenderStatus == stat) // todo additional agreement якшо є не додаткове то вертати його
    },
    $_agreements() {
      if (this.$can('set', 'useCommonAgreements')) {
        const result = [...this.$_stageAgreements] || []
        return result
          .map(s =>
            s.agreements
              .map(a => ({
                stageNumber: s.stageNumber,
                ...a
              })
              )
          )
          .flat(1) || []
      }
      return this.$_stageAgreements?.length ? this.$_stageAgreements[0].agreements : []
    },
  },
  methods: {
  /**
   * Замолняем свойства по старой логике бизнеспроцессов
   */
    $_setAggrementProps(value) {
      const objectAgreement = value[0] || {}
      const tenderEvent = this.$_.cloneDeep(this.tender)
      if (tenderEvent.agreements === undefined) {
        this.$set(tenderEvent, 'agreements', null)
      }
      if (objectAgreement?.comment) {
        this.$set(tenderEvent, 'acceptorComment', objectAgreement?.comment)
      }
      if (objectAgreement?.type) {
        this.$set(tenderEvent, 'acceptorType', objectAgreement?.type)
      }
      if (objectAgreement.processEnded) {
        this.$set(tenderEvent, 'agreementEnded', objectAgreement?.processEnded || false)
      }
      tenderEvent.agreements = objectAgreement?.agreements
      this.$emit('update:tender', tenderEvent)

      const eventObject = {
        acceptors: this.$_.cloneDeep(tenderEvent.agreements) || []
      }
      eventObject.disagreeButtonTitle = objectAgreement.disagreeButtonTitle
      eventObject.agreeButtonTitle = objectAgreement.agreeButtonTitle
      eventObject.hideDisagreeButton = objectAgreement.hideDisagreeButton
      this.$_setCanEdit()
      this.$emit('changeAcceptors', {agreements: eventObject})
    },
    $_setCanEdit: debounce(async function () {
      try {
        this.$set(this, 'can_edit', this.$_checkCanEdit(this.tender, this.$_agreements))
      } catch (err) {
        return null
      }
    }, 250),
    /**
   * Замолняем свойства по новой логике бизнеспроцессов
   */
    $_setStageAgreementProps(value) {
      const tenderEvent = this.$_.cloneDeep(this.tender)
      if (tenderEvent.agreements === undefined) {
        this.$set(tenderEvent, 'agreements', null)
      }
      if (tenderEvent.stageAgreements === undefined) {
        this.$set(tenderEvent, 'stageAgreements', null)
      }
      tenderEvent.stageAgreements = value
      tenderEvent.agreements = this.$_agreements
      this.$emit('update:tender', tenderEvent)

      const firstAgreement = value.find(i => i.agreements.find(a => a.status === 'WAITING')) || {}

      const eventObject = {
        acceptors: this.$_.cloneDeep(this.$_agreements) || []
      }
      eventObject.disagreeButtonTitle = firstAgreement.disagreeButtonTitle
      eventObject.agreeButtonTitle = firstAgreement.agreeButtonTitle
      eventObject.hideDisagreeButton = firstAgreement.hideDisagreeButton
      this.$_setCanEdit()
      this.$emit('changeAcceptors', {agreements: eventObject})
    },
    $_setAgreementValues(res) {
      res = res.map((i, ii) => ({
        stageNumber: ii + 1,
        ...i
      }))
      const resObject = []
      res.forEach((stage, stageIndex) => {
        stage.stageNumber = stageIndex
        stage.agreements = stage.agreements.map((i, ii) => ({
          aggreeNumber: ii + 1,
          ...i
        }))
        resObject.push(stage)
      })
      this.$store.commit('setAgreements', {items: resObject})

      if (this.$can('set', 'useCommonAgreements')) {
        this.$_setStageAgreementProps(resObject)
      } else {
        this.$_setAggrementProps(resObject)
      }
    },
    /**
   * Проверяем что текущий пользователь активный согласовант
   * @param {Object} agreements {acceptors: Array, disagreeButtonTitle: Boolean, agreeButtonTitle: Boolean, hideDisagreeButton: Boolean}
   * @returns
   */
    $_checkImAcceptor(agreements) {
      /** берем первую запись по себе с статусом ожидаение.
    * Т.к. с бека все приходит отсортированно,
    * то основные БП будут первыми
    * */
      const result = agreements?.acceptors?.find(el => el.isMy && el.status == 'WAITING')
      if (result) {
        result.disagreeButtonTitle = agreements?.disagreeButtonTitle
        result.agreeButtonTitle = agreements?.agreeButtonTitle
        result.hideDisagreeButton = agreements?.hideDisagreeButton
      }
      return result
    },
    $_checkCanEditStage(tender, stage) {
      const showServiceMessage = false//['development', 'staging'].includes(window.config?.node_env)
      if (this.$acl.get.includes('tenders_view')) {
        if (showServiceMessage) { this.$sinfo('Я в группе ролей "только на просмотр"') }
        return false
      }

      /* Тендер из вебклиента */
      if (tender?.hasRoute) {
        if (showServiceMessage) { this.$sinfo('Тендер из вебклиента') }
        return false
      }

      let stageAgreements = []
      if (this.$_stageAgreements?.length) {
        stageAgreements = this.$_stageAgreements
      } else if (stage?.length) {
        stageAgreements = stage
      }

      const mainBps = stageAgreements.filter(i => !i.isAdditional && i.activeStatus === 'ACTIVE') || []
      /** после согласования бек меняет признак editWhileAgree на false. Поэтому, не проверяем свой статус */
      const mainBpsHasMy = mainBps.filter(i => !!i.agreements.find(a => a.isMy)) || []

      const notMainBps = stageAgreements.filter(i => i.isAdditional && i.activeStatus === 'ACTIVE') || []
      /** после согласования бек меняет признак editWhileAgree на false. Поэтому, не проверяем свой статус */
      const notMainBpsHasMy = notMainBps.filter(i => !!i.agreements.find(a => a.isMy)) || []

      /** если нет активных БП редактировать можно */
      if (!mainBps?.length && !notMainBps?.length) {
        if (showServiceMessage) { this.$sinfo('нет активных БП') }
        return this.$acl.check('onlyTenders')
      }

      /** Я согласовантов в активной стадии. Приоритет у основного БП */
      let myBp = {}
      if (mainBpsHasMy?.length) {
        myBp = mainBpsHasMy[0]
      } else if (notMainBpsHasMy?.length) {
        myBp = notMainBpsHasMy[0]
      }
      if (Object.keys(myBp)?.length) {
        if (showServiceMessage) { this.$sinfo('Я согласовантов в активной стадии и editWhileAgree: true') }
        return myBp.editWhileAgree
      }

      if (showServiceMessage) { this.$sinfo('Ни одно из условий $_checkCanEditStage не дало true') }
      return false
    },
    $_checkCanEdit(tender, agreements, stage) {
      if (this.$can('set', 'useCommonAgreements')) {
        return this.$_checkCanEditStage(tender, stage)
      }

      const acceptors = agreements?.acceptors || this.$_agreements || []
      let my_agreement = acceptors?.find(el => el.isMy)
      let cant_edit = this.has_required_agreement && acceptors.length && (!this.$_stageAgreements[0]?.editWhileAgree || my_agreement?.isAdditional)
      let is_agreed = this.$_checkAgreementFinished(acceptors)

      return this.$acl.check('onlyTenders') && !tender?.hasRoute && (!cant_edit || is_agreed)
    },
    /**
   * Првоеряем наличие ожидающих основных согласовантов
   * @param {Array} agreements
   * @returns
   */
    $_checkAgreementFinished(agreements) {
      return !agreements?.some(el => el.status == 'WAITING' && !el?.isAdditional)
    },
    $_minTenderPeriodDate() {
      this.$store.dispatch('setMinPproposalsDate')
      return this.$store.getters.getMinPproposalsDate
    },
    async $_getSubscribed(tender) {
      return await this.$store.dispatch('subscribedUsers', { tenderId: tender.tenderId })
    },
    changeStep(next) {
      let info = this.$store.getters['getNewTenderInfo'],
        tenderInfo = this.$store.getters['getNewTender'],
        step = next ? info.step + 1 || 1 : info.step - 1 || 0,
        mode = info.mode || 'new'
      if (tenderInfo.tenderId) {
        sessionStorage.setItem(`tender_step:${tenderInfo.tenderId}`, step)
        sessionStorage.removeItem('tender_step: tender')
      } else if (step && step <= info.steps?.length) {
        sessionStorage.removeItem('tender_step: tender', step)
      }
      if (step > info.steps?.length || step == 0) {
        this.$store.commit('setNewTenderInfo', {})
        this.$router.push(mode == 'edit' ? {
          name: 'tenderitem',
          params: { id: this.$route.params?.id || this.$route.query?.id, org: this.$route.params.org }}
          : {name: 'tenders', params: { org: this.$route.params.org }})
      } else {
        this.$store.commit('setNewTenderInfo', {...info, step })
        this.$router.push({
          name: this.$route.name,
          query: {...this.$route.query, step, id: tenderInfo.tenderId},
          params: { org: this.$route.params.org }
        })
      }
    },
    $_getDeliveryDate(items) {
      let last_date = moment(Math.min(...items.filter(el => el.approvedSupplyDate).map(el => Date.parse(el.approvedSupplyDate))))
      if (last_date.isValid()) {
        let result = last_date > this.min_period_date && moment(last_date).format('YYYY-MM-DD')
        return result
      }
    },
    getCurrentSumm(tender, positionItem) {
      let result = 0
      result = tender?.biddingType?.recalcTotalSummByReducedPrice
        ? positionItem.quantity * positionItem.reducedPrice // https://app.clickup.com/t/8678paa3u Моя приведена ціна*Кількість
        : positionItem.quantity * positionItem.currencyPrice

      result = result || 0
      return Math.round((result + Number.EPSILON) * 100) / 100
    },
    $_getGroupsPositionsByLot(bids, filterProps) {
      if (!bids?.length) { return [] }

      /**
     * Для розбиття "Переможці/Інші учасники" беремо selectedBid групи лотів
     * (bidGroupDetails), а не окремої позиції — всередині групи лотів позиції
     * можуть мати різний selectedBid (лише одна позначена), інакше та сама
     * група потрапляє одразу в обидва блоки з однаковими агрегованими даними
     */
      const groupSplitValue = (bid) => {
        if (filterProps.value !== 'selectedBid') {
          return bid[filterProps.value]
        }
        const backendGroup = bid.groupId != null
          ? bid.bidGroupDetails?.find(g => g.groupId === bid.groupId)
          : null
        return backendGroup ? backendGroup.selectedBid : bid.selectedBid
      }

      const groups = this.$_.groupBy(bids, filterProps.value === 'selectedBid' ? groupSplitValue : filterProps.value)

      const result = Object.entries(groups).map(([key, groupBids], order) => {
        const first = groupBids[0]
        let title = first.name || first.bidderInfo?.organizationName || ''

        if (filterProps.value === 'lotGroupNumber') {
          const lotGroupNumber = first.lotGroupNumber || order  + 1
          title = `#${lotGroupNumber} ${first.lotGroupTitle}`
        } else if (filterProps.value === 'selectedBid') {
          title = key === 'true' ? this.$t('Tenders.Winners') : this.$t('Tenders.OtherParticipants')
        }

        const byLotGroup = this.$_.groupBy(groupBids, filterProps.positionValue)

        const items = Object.entries(byLotGroup).map(([, positions]) => {
          positions = positions.map(positionItem => ({
            ...positionItem,
            currencySumm: this.getCurrentSumm(this.tender, positionItem)
          }))
          const lotFirst = positions[0]

          /**
         * Якщо позиції належать до групи лотів, беремо дані самої групи
         * (bidGroupDetails), сформовані бекендом
         */
          const backendGroup = lotFirst.groupId != null
            ? lotFirst.bidGroupDetails?.find(g => g.groupId === lotFirst.groupId)
            : null
          if (backendGroup) {
            positions = backendGroup.bidDetails
          }
          positions = this.$_.sortBy(positions, 'lotNumber')

          const selectedBid = backendGroup ? backendGroup.selectedBid : positions.some(p => p.selectedBid)
          const attachments = this.$_.uniqBy(positions.reduce((sum, p) => sum.concat(p.attachments || []), []), 'key')

          const hasPositionNotSelectedBid = positions.some(i => !i.selectedBid)

          return {
            unigueKey: positions.map(i => i.idBidRow).join('_'),
            groupId: lotFirst.groupId,
            lotGroupNumber: lotFirst.lotGroupNumber,
            lotGroupTitle: lotFirst.lotGroupTitle,
            bidStatus: lotFirst.bidStatus,
            currencyTitle: lotFirst.currencyTitle,
            price: backendGroup ? backendGroup.price : lotFirst.price,
            currencyId: lotFirst.currencyId,
            bidderInfo: lotFirst.bidderInfo,
            ipAddress: lotFirst.ipAddress,
            timeSupplyBids: lotFirst.timeSupplyBids,
            currencySumm: backendGroup ? backendGroup.price : positions.reduce((sum, p) => sum + (p.currencySumm || 0), 0),
            totalCost: positions.reduce((sum, p) => sum + this.getCurrentSumm(this.tender, p), 0),
            bestPrice: backendGroup ? backendGroup.bestPrice : lotFirst.bestPrice,
            bidDecisionAttribute: backendGroup ? backendGroup.bidDecisionAttribute : lotFirst.bidDecisionAttribute,
            remark: lotFirst.remark,
            hasPositionNotSelectedBid,
            attachments,
            all_criteria: positions[0].all_criteria,
            attachmentCount: attachments.length,
            selectedBid,
            positions,
          }
        })

        return {
          title: title,
          items,
          selected: [],
          id: `bidLotGroup_${title}`,
          order: order + 1,
        }
      })

      if (filterProps.value === 'selectedBid') {
        result.sort((a, b) => {
          const aWinner = a.items.some(item => item.selectedBid)
          const bWinner = b.items.some(item => item.selectedBid)
          return (bWinner ? 1 : 0) - (aWinner ? 1 : 0)
        })
      }

      return result
    },
    /**
   * Групування по переможцям   //todo перенести в модальний міксін
   *
   * @param {Array} bids
   */
    $_getGroupsByWinners(bids, filter, modify) {
      let status = this.tender?.tenderStatus?.id,
        cancelled = status === this.statuseKeys.PURCHASE_NOT_PLACED,
        ended = status === this.statuseKeys.COMPLETED,
        analis = status === this.statuseKeys.BID_ANALYSIS
      if (analis || ended || (cancelled && this.change_winner_mode)) {
        let func = (item) => {
          let winners = eval(item.title),
            result = {
              ...item,
              winners,
              title: winners ? this.$t('Tenders.Winners') : this.$t('Tenders.OtherParticipants')
            }
          if (modify) {
            result = modify(result)
          }
          return result
        }
        return this.getGroups(
          bids,
          filter || 'selectedBid',
          func ,
          (a, b) => +b.winners - +a.winners)
      } else {
        return this.getGroups(bids)
      }
    },
    /**
   * Групування    //todo перенести в модальний міксін
   *
   * @param {Array} bids
   * @param {Function , String, Array } (lodash groupBy) filter
   * @param {Function} modify
   * @param {Function} sort
   * @returns Array
   */
    getGroups(bids, filter, modify, sort) {
      let groups = Object.entries(this.$_.groupBy(bids, filter)).map(([name, items], index) => {
        let result = {
          title: name,
          items,
          selected: [],
          id: name + '' + index
        }
        if (modify) {
          result = modify(result)
        }
        return result
      })
      return sort ? groups.sort(sort) : groups
    },
    /**
     * В обазяательном порядке нужны данные валют currencies
     * await this.$store.dispatch('setCurrencies')
     *   .then(res => this.currencies = res)
     */
    getBids(items, tender, without_curr, mapBid) {
      if (!items || !items.length) { return [] }
      let bids = []
      const mapDocs = (docs) => {
        if (docs?.length) {
          return docs?.map(file => {
            const result = file.id ? new TenderFile(tender.tenderId, file.id, file.key, null, file.title, file.size) : file
            result.isActive = file.isActive
            return result
          })
        } else {
          return []
        }
      }
      const chackDocs = (criteria) => {
        criteria.forEach(criteriaItem => criteriaItem.attachments = mapDocs(criteriaItem.attachments))
      }

      items.forEach((item) => {
        const bidGroupByDetailId = new Map()
        item.bidGroupDetails?.forEach((group) => {
          const groupIndex = tender.lotGroups?.findIndex(lotGroup => lotGroup.id === group.groupId) ?? -1
          group.bidDetails?.forEach(groupDetail => bidGroupByDetailId.set(groupDetail.id, { group, groupIndex }))
        })

        /**
       * Будуємо позицію заявки як для плоского списку bidDetails, так і для позицій
       * всередині bidGroupDetails (бек присилає для них той самий набір полів)
       */
        const buildBidDetail = (details, n, groupInfo) => {
          let bid = this.$_.cloneDeep(details)

          chackDocs(bid.criteria)
          chackDocs(item.criteria)
          this.$set(bid, 'verification', item.verification)
          this.$set(bid, 'bidderInfo', item.bidderInfo)
          this.$set(bid, 'contract', item.contract)
          this.$set(bid, 'contractCount', item.contractCount || {})
          this.$set(bid, 'contractStatus', item.contractStatus || {})
          this.$set(bid, 'tender_criteria', item.criteria)
          this.$set(bid, 'remark', item.remark)
          this.$set(bid, 'foreignBidderBid', item.foreignBidderBid)
          this.$set(bid, 'attachments', mapDocs(item.attachments))
          this.$set(bid, 'name', item.bidderInfo?.organizationName)
          this.$set(bid, 'participant', item.bidderInfo?.contactId || item.bidderInfo?.email + '_' + item.bidderInfo?.usreou)
          this.$set(bid, 'summ', + (bid.quantity * bid.currencyPrice).toFixed(2))
          this.$set(bid, 'index', bid.bidderInfo?.usreou + '' + bid.lotId + bid.id + '' + n)
          this.$set(bid, 'org_num', bid.bidderInfo?.usreou)
          const lotTitle = tender.lots.find(el => el.lotId == (bid.lotId))?.title
          const lotGroupTitle = groupInfo?.group.title
          this.$set(bid, 'lotGroupNumber', groupInfo ? groupInfo.groupIndex + 1 : null)
          this.$set(bid, 'lotGroupTitle', lotGroupTitle)
          this.$set(bid, 'lotTitle', lotGroupTitle ? `${lotGroupTitle.trim()} ${lotTitle}` : `#${details.lotNumber} ${lotTitle}`)
          this.$set(bid, 'lotTitleOrig', lotTitle)
          this.$set(bid, 'lotQuantity', tender.lots.find(el => el.lotId == (bid.lotId))?.quantity)
          this.$set(bid, 'ipAddress', item.ipAddress)
          this.$set(bid, 'groupId', groupInfo?.group.groupId)
          this.$set(bid, 'groupPrice', groupInfo?.group.price)

          const defaultCriteria = {
            warrantyYears: bid.warrantyYears ? bid.warrantyYears : null,
            termsDelivery: bid.termsDelivery ? bid.termsDelivery : null,
            deliveryTime: bid.deliveryTime ? bid.deliveryTime : null,
            termsPayment: bid.termsPayment ? bid.termsPayment : null,
          }

          this.$set(bid, 'all_criteria', [
            ...(Object.values(defaultCriteria).some(value => value !== null) ? [{ name: 'default', items: defaultCriteria }] : []),
            ...(bid.tender_criteria?.length ? [{ name: 'ToTender', items: bid.tender_criteria }] : []),
            ...(bid.criteria?.length ? [{ name: 'ToLot', items: bid.criteria }] : []),
          ])
          if (mapBid) {
            bid = mapBid(bid)
          }
          if (!without_curr) {
            let curr = this.$_.find(this.currencies, {'code': bid.currencyId})

            this.$set(bid, 'currency', curr)
            this.$set(bid, 'currencyTitle', curr?.shortTitle || (this.$_getShortName && this.$_getShortName(curr?.title)) || curr?.title || tender.currency?.title || '–')
          }

          return bid
        }

        const bidById = new Map()
        item.bidDetails.forEach((details, n) => {
          const bidGroup = bidGroupByDetailId.get(details.id)
          const bid = buildBidDetail(details, n, bidGroup)
          bidById.set(details.id, bid)

          bids.push(bid)
        })

        /**
       * bidGroupDetails.bidDetails містить лише id-поля — повні дані беремо
       * з уже побудованих позицій item.bidDetails (щоб не дублювати важкі поля в gql-запиті).
       * Кладемо туди поверхневі копії, а не самі bid-и — інакше bid.bidGroupDetails
       * містив би масив, що посилається сам на себе (circular structure)
       */
        item.bidGroupDetails = item.bidGroupDetails?.map(group => ({
          ...group,
          bidDetails: group.bidDetails?.map(groupDetail => {
            const bid = bidById.get(groupDetail.id)
            return bid ? { ...bid } : null
          }).filter(Boolean) || [],
        }))

        bidById.forEach(bid => this.$set(bid, 'bidGroupDetails', item.bidGroupDetails))
      })

      return bids
    },
    /**
   * Добавляем в модель тендера свойство с доступами
   * @param {*} tender
   * @returns
   */
    async $_updateTenderAccess(tender) {
      if (!tender?.tenderId) {
        return
      }
      await st_api.getTenderAccess(tender.tenderId)
        .then(res => {
          tender.tenderAccess = res
        })
    },
    /* По идее, не используется. 29.02.2024
  async setCurrencies(items) {
   let currencies
   await this.$store.dispatch('setCurrencies')
    .then(res => currencies = res)
   items.forEach(bid => bid.currency = currencies?.find(el => el.code == bid.currencyId))
   return items
  },*/
    async $_updateStatus(tender) {
      await st_api.tenderStatus(tender.tenderId)
        .then(res => {
          tender.tenderStatus = {...res, id: res?.statusCode }
          tender.tenderStatusId = res?.statusCode
          tender.tenderStatusTitle = res?.title
        })
    },
    $_filterMembersBySearch(item) {
      if (!this.search) {
        item.filtred_users = null
        item.expanded = false
        return true
      }
      let search = this.search.toLowerCase()
      if (item.organisations) {
        item.filtred_orgs = item.organisations.filter(this.$_filterMembersBySearch)
      } else {
        item.filtred_users = item.users?.filter(u => u.userName?.toLowerCase().includes(search)
     || u.email?.toLowerCase().includes(search)
     || u.name?.toLowerCase().includes(search))
      }

      let result = item.organizationTitle?.toLowerCase().includes(search)
    || item.organizationUsreou?.toString().includes(search)
    || item.groupName?.toString().includes(search)
    || item.filtred_users?.length
    || item.filtred_orgs?.length
      if (result) {
        item.expanded = true
      } else {
        item.expanded = false
      }
      return result
    },
    $_getSubscribersUseers() {
      return this.$_getUseers(this.subscribedToCategory)
    },
    $_getUseers(items) {
      if (!items?.length) {
        return []
      } else {
        let users = []
        items.forEach(el => users.push(...el.users.map(it => {
          return {
            ...it,
            organizationId: el.organizationId,
            supplierRatings: el.supplierRatings,
            organizationTitle: el.organizationTitle,
            organizationUsreou: el.organizationUsreou,
          }
        })))
        return this.$_getUnicByEmail(users)
      }
      // else if (items.every(el => el.count)) {
      //  return items.reduce((res, item) => res += item.count, 0)
      // }

    },
    $_checkRuEmailDomen(items) {
      const blockDomen = ['ru', 'рф', 'рус', 'su']
      return items.map(i => ({
        ...i,
        blockDomen: blockDomen.some(s => i.email.endsWith(s))
      }))
    },
    $_getUnicByEmail(items) {
      if (!items) {
        return items
      }
      items = items.map(i => ({...i, email: i.email?.toLowerCase()}))
      return this.$_.uniqBy(items, function (e) {
        return e.contactId || e.email
      })//'email')
    },
    $_copyUsreou(item) {
      this.copy(item.bidderInfo?.usreou)
    },
    copy(text) {
      if (text) {
        navigator.clipboard.writeText(text)
      }
    },
    async $_setHeaders(edit_name) {
      let titleSort = []
      let bidding_type = this.tender.biddingType,
        bid_type_id = bidding_type?.biddingTypeId,
        auction = this.$store.getters['getNewTenderInfo']?.mode == 'add-data', // this.is_dialog //
        is_multistaged = bidding_type?.isMultistage,
        can_edit_name = edit_name && !this.tender.applicationBased && !auction && bidding_type.isFrameAuction
      this.headers = [
        {text: this.$t('Catalog.Position'), value: 'lotSubject', sortable: false , cellClass: can_edit_name ? '' : 'secondary__green_chosen', disable: !can_edit_name },
        {text: this.$t('Tenders.AdditionalDescription'), value: 'description', sortable: false,
          width: '20%', cellClass: auction ? 'secondary__green_chosen' : '', disable: auction },
        {text: this.$t('Catalog.Amount'), value: 'quantity', sortable: false, width: '9%',
          cellClass: auction ? 'secondary__green_chosen' : '', disable: auction },
        // {text: '', value: '', sortable: false, width: '1%' , cellClass: auction ? 'secondary__green_chosen' : ''}
      ]
      if (!bidding_type.tenderingForPercentage
    && (!bid_type_id || bidding_type?.initialRateAvailable)
    && (!is_multistaged || auction)
    && (this.$can('set', 'BudgetType', 'AMOUNT')
     || this.$can('set', 'BudgetType', 'AMOUNT_AND_MINIMAL_STEP')
    )) {
        this.headers.push(
          { text: this.$t('Tenders.StartingPrice'), value: 'startAmount', sortable: false, width: '10%' },
          { text: this.$t('Tenders.TotalPrice'), value: 'summ', sortable: false, width: '12%', cellClass: 'secondary__green_chosen' }
        )
        this.headers[this.headers.length - 1].cellClass = 'secondary__green_chosen'
      }

      if (bidding_type?.hasLimitBidPrice) {
        this.headers.push(
          { text: this.$t('Tenders.MinPrice'), value: 'bidPriceLimit', sortable: false, width: '10%' },
        )
      }

      if ((!bid_type_id || bidding_type?.bidStepAvailable) && (!is_multistaged || auction) &&
    (this.$can('set', 'BudgetType', 'MINIMAL_STEP')
     || this.$can('set', 'BudgetType', 'AMOUNT_AND_MINIMAL_STEP'))) {
        this.headers.splice(-1, 0,
          { text: this.$t('Tenders.RatesStep'), value: 'bidStep', sortable: false, width: '9%' })
      }
      if (this.$can('set', 'deliveryAddress')) {
        this.headers.splice(-1, 0,
          { text: this.$t('Catalog.DeliveryAddress'), value: 'addressId', sortable: false,
            width: '12%', cellClass: this.auction ? 'secondary__green_chosen' : '', disable: auction })
      }

      if (bidding_type.tenderingForPercentage) {
        this.headers.splice(-1, 0,
          { text: `${this.$t('Tenders.StartingBid')}`, value: 'startAmount', sortable: false, width: '10%' }
        )
        this.headers.find(i => i.value === 'bidStep').text = this.$t('Tenders.IncreaseStep')

        titleSort = ['lotSubject', 'description', 'startAmount', 'bidPriceLimit', 'bidStep', 'quantity']
      }
      if (bidding_type.minimalQuantity) {
        this.headers.push(
          { text: this.$t('Tenders.MinimalQuantity'), value: 'minimalSubmitQuantity', sortable: false, width: '110px' }
        )
      }

      if (bidding_type.saleWithDiscount) {
        this.headers.push(
          { text: this.$t('Catalog.Price'), value: 'discounts', sortable: false, width: '225px' }
        )
        const indexToDelete = this.headers.findIndex(i => i.value === 'startAmount')
        this.headers.splice(indexToDelete, 1)
        titleSort = ['lotSubject', 'description', 'quantity', 'minimalSubmitQuantity', 'discounts', 'bidStep', 'summ']
      }

      // Если указан порядок, то сортируем колонки
      if (titleSort?.length) {
        titleSort.forEach((item, index) => {
          if (this.headers.find(i => i.value === item)) {
            this.headers.find(i => i.value === item).order = index
          }
        })
        this.headers.sort((a, b) => a.order - b.order)
      }
    },
    async $_uploadFiles(files) {
      let promises = files.filter(file => !file.id).map(async (file,) => {
        return await file.uploadFile()
          .catch(er => {
            this.files = this.files.slice(0)
            file.catchUploading(er)
          })
      })
      await Promise.allSettled(promises)
    },
    async uploadAdditionalDocument(files) {
      let promises = files.filter(file => !file.id).map(async (file,) => {
        return await file.uploadAdditionalDocument()
          .catch(er => {
            this.files = this.files.slice(0)
            file.catchUploading(er)
          })
      })
      await Promise.allSettled(promises)
    },
    async uploadPublicTenderResultDocument(files) {
      let promises = files.filter(file => !file.id).map(async (file,) => {
        return await file.uploadPublicTenderResultDocument()
          .catch(er => {
            this.files = this.files.slice(0)
            file.catchUploading(er)
          })
      })
      await Promise.allSettled(promises)
    },
    async getLotsFromStorage() {
      let from_plan = sessionStorage.getItem('tender_step: from_plan')
      if (from_plan && !this.tender.lots) {
        let items, ids = from_plan.split(',').map(el => el.split('/'))
        await this.$store.dispatch('getPurchasingPlans', {}).then(res => items = res?.items)
        this.tender.lots = items.filter(item => ids.some(id => id[0] == item.rowId && item.headerId == id[1]))
      }

      if (this.tender.lots?.length && !this.tender.lots[0]?.lotSubject) {
        sessionStorage.setItem('tender_step: from_plan', this.tender.lots.map(el => el.index || el.rowId + '/' + el.headerId))
        this.rows = this.tender.lots.slice(0)
        let date = this.$_getDeliveryDate(this.tender?.lots)
        if (date) {
          this.$set(this.tender, 'deliveryPeriodTo', moment(date).format('YYYY-MM-DDTHH:mm:ss'))
        }

        this.$set(this.tender, 'tenderCurrency', this.tender.lots[0].currency?.symbol)

        let group = this.$_.groupBy(this.tender.lots,lot => lot.resource?.name || lot.resourceName)

        group = Object.entries(group).map((lot, i) => {
          let rows = lot[1], undoc = this.$_.groupBy(rows, 'headerId')
          return {
            lotNumber: i + 1,
            lotSubject: lot[0],
            // undocRows: Object.entries(undoc).map(und => ({ headerId: +und[0], rowsIds: und[1].map(row => row.id) })),
            measuringUnit: rows[0]?.unit?.publicId , // || 'H87' ,
            quantity: rows.reduce((total, el) => total + el.approvedQuantity , 0) || 1,
            minimalSubmitQuantity: rows[0]?.minimalSubmitQuantity,
            bidPriceLimit: rows[0]?.bidPriceLimit,
            startAmount: Math.max(...rows.map(el => el.price)) || 0,
            bidStep: 0,
            description: rows.map(lot => lot.description).join('\r\n').trim() || '',
            category: rows[0]?.resource?.category,
            codeCpv: rows[0]?.resource?.category?.code,
            // addressId: rows[0]?.receiver?.id,
            applicationRowsKey: Object.entries(undoc).map(([headerId, rows]) => ({ headerId: +headerId, rowsIds: rows.map(row => row.rowId) }))
          }
        })
        this.positions = this.tender.lots = group
      } else {
        this.positions = this.tender.lots

      }
    },
    $_updateSupplierVerification(props) {
      return new Promise((resolve) => {
        if (props.tenderId !== this.tender.tenderId || !this.crmSupplierVerificationByTender?.length) {
          resolve()
          return
        }
        const index = this.crmSupplierVerificationByTender.findIndex(i => i.supplierOrganizationId === props.model.supplierOrganizationId)

        if (index !== -1) {
          this.crmSupplierVerificationByTender[index].decisionType = props.model.decisionType
          this.crmSupplierVerificationByTender[index].comment = props.model.comment
          this.crmSupplierVerificationByTender[index].verificationStatus = props.model.verificationStatus
        }
        resolve()
      })
    },
    $_getCrmSupplierVerificationByTender() {
      if (this.crmSupplierVerificationByTenderLoaded) {
        return Promise.resolve(this.crmSupplierVerificationByTender)
      }
      if (!this.$_crmSupplierVerificationByTenderPromise) {
        this.$_crmSupplierVerificationByTenderPromise = suppliers_api.getCrmSupplierVerificationByTender(this.tender.tenderId)
          .then((result) => {
            this.crmSupplierVerificationByTender = result
            this.crmSupplierVerificationByTenderLoaded = true
            this.$_crmSupplierVerificationByTenderPromise = null
            return result
          })
      }
      return this.$_crmSupplierVerificationByTenderPromise
    },
    $_setCrmSupplierVerificationByTender(user) {
      return new Promise((resolve) => {
        if (!user?.length) {
          resolve()
          return
        }
        this.$_getCrmSupplierVerificationByTender()
          .then(res => {
            user?.forEach((user) => {
              user.verification = res?.find((i => i.supplierOrganizationId === user.bidderInfo?.organizationId || user.organizationId)) || {}
            })
            resolve()
          })
      })
    },
    $_setContracts(winners) {
      return new Promise((resolve) => {
        if (!this.contranctProps || this.contranctProps?.contractLoad) {
          resolve()
          return
        }
        if (winners?.length && this.tender.tenderStatus.id == 10) {
          this.contranctProps.contractLoad = true
          let setContract = (docArray, itemArray) => new Promise((resolve) => {
            itemArray.forEach(winner => {
              let usreou = winner.organizationUsreou || winner.usreou || winner.org_num || winner.bidderInfo.usreou || ''
              const lotId = winner.lotId

              const allDoc = docArray.filter(item => item.winnersEdrpou?.trim() === usreou?.trim() && (!lotId || item.lotIds.includes(lotId))) || []

              let doc = allDoc.filter(item => item.type !== 'ADDITIONAL_AGREEMENT') || []
              let approving = allDoc.filter(item => item.type === 'ADDITIONAL_AGREEMENT') || []
              const getStatus = (doc) => {
                if (!doc?.length) {
                  return {}
                }
                return {
                  state: doc[0].status,
                  color: this.$t('Tenders.ContractStatus.' + doc[0].status + '.color')
                }
              }

              if (doc?.length) {
                winner.contractCount = {
                  all: doc?.length + approving?.length,
                  contract: doc?.length,
                  approving: approving?.length,
                }
                winner.contract = doc
                winner.approving = approving.sort((a, b) => {
                  return new Date(a.documentDate).getTime() - new Date(b.documentDate).getTime()
                })
                winner.contractStatus = getStatus(doc)
              }
            })
            resolve(itemArray)
          })
          if (this.contranctProps.contract) {
            setContract(this.contranctProps.contract, winners)
              .then((result) => {
                winners = result
                this.contranctProps.contractLoad = false
                resolve()
                return
              })
          }
          if (!this.contranctProps.contractLoaded) {
            signy_api.getContractInfoByTender(this.tender.tenderId)
              .then(res => {
                res = res?.data?.getContractInfoByTender
                res = res.map(i => ({...i, documentNumber: i.additionalAgreementNumber || i.contractNumber || '-'}))
                this.contranctProps.contract = res
                if (!res?.length) { return }
                setContract(res, winners)
                  .then((result) => {
                    winners = result
                    this.contranctProps.contractLoad = false
                    resolve()
                  })
              })
              .finally(() => {
                this.contranctProps.contractLoad = false
                this.contranctProps.contractLoaded = true
              })
          }
        } else {
          this.contranctProps.contractLoad = false
          this.contranctProps.contractLoaded = true
          resolve()
        }
      })
    },
    getStatus(tender, statuses) {
      let shedule = tender.tenderPublishedSchedule,
        sheduled = shedule?.isScheduled && shedule?.scheduledDate,
        status = tender.tenderStatusId || tender.tenderStatus?.id || tender.tenderStatus,
        result = {
          id: '',
          title: ''
        }
      if (status === this.statuseKeys.REGISTRY && sheduled) {
        if (moment(sheduled).format('x') > moment().format('x')) {
          result.title = this.$t('Tenders.AwaitingPublication')
          result.id = '1.1'
        } else if (moment(sheduled).format('x') < moment().format('x')) {
          result.title = this.$t('Tenders.PublicationError')
          result.id = '1.2'
        }
      } else {
        result.title = tender.tenderStatusTitle || tender.tenderStatus?.title || statuses?.find(el => el.statusCode == status)?.title || ''
        result.id = status
      }
      return result
    },
    async checkTenderBySettings(tender) {
      await this.checkIndividualsAllowed(tender)
      await this.checkIsAllowParticipantCancelBid(tender)
      await this.checkPreviousMailing(tender)
    },
    async checkIndividualsAllowed(tender) {
      let is_sale = tender?.biddingType?.isSale

      if (!is_sale) {
        tender.areIndividualsAllowed = false
      } else if (this.$can('set', 'AllowIndividualsParticipation', 'ALWAYS')) {
        tender.areIndividualsAllowed = true
      } else if (is_sale && this.$can('set', 'AllowIndividualsParticipation', 'BY_DEFAULT')) {
        tender.areIndividualsAllowed ??= true
      } else if (this.$can('set', 'AllowIndividualsParticipation', 'NONE')) {
        tender.areIndividualsAllowed = false
      } else {
        tender.areIndividualsAllowed ??= false
      }
    },
    async checkPreviousMailing(tender) {
      if (this.$can('set', 'tenderPublicationPlaningMode', 'DISABLE')) {
        tender.previousMailing = null
      } else {
        tender.previousMailing ??= false
      }
    },
    async checkIsAllowParticipantCancelBid(tender) {
      if (this.$can('set', 'IsAllowParticipantCancelBid', 'ALWAYS_ON')) {
        tender.allowParticipantBidCancellation = true
      } else if (this.$can('set', 'IsAllowParticipantCancelBid', 'SHOW_DEFAULT_OFF')) {
        tender.allowParticipantBidCancellation ??= false
      } else if (this.$can('set', 'IsAllowParticipantCancelBid', 'ALWAYS_OFF')) {
        tender.allowParticipantBidCancellation = false
      } else {
        tender.allowParticipantBidCancellation ??= true
      }
    },
    /**
   * Пробрасываем событие отмены тендера
   */
    async tenderCancel() {
      this.$root.$emit('showOverlay')
      this.$root.$emit('tenderUpdate', true)
      this.$root.$emit('closeOverlay')
      this.$forceUpdate()
    },
    /**
   * Зберегти/прибрати тендер як шаблон
   * @param {*} tender
   * @returns
   */
    toggleTemplateInMainPage: debounce(async function (tender) {
      this.toggleTemplate(tender)
        .then(async res => {
          if (!res.result?.success) {
            return
          }

          let typeCount = this.$store.getters['gettendersCountsByTypes']
          let new_count = res.isTemplate ? typeCount.templatesCount + 1 : typeCount.templatesCount - 1 // изменяем значение в статистике
          this.$store.commit('settendersCountsByTypes', {...typeCount, templatesCount: new_count}) // применяем новую статистику
          await this.$_getFiltersFromDBStorage()
            .then(async (storage_filters) => {
              if (storage_filters.additionalFilter == 'TEMPLATES') {
                this.$store.commit('setTenders', this.$store.getters['getTenders']?.filter(item => item.tenderId != tender.tenderId)) // применяем массив тендеров без того что убрали из шаблонов
              }
            })
        })
    }, 250),
    /**
   * Вызов изменения статуса шаблона
   * @param {*} tender
   * @returns
   */
    async toggleTemplate(tender) {
      let res
      try {
        if (tender.isTemplate) {
          res = await st_api.removeTenderFromTemplate(tender.tenderId)
        } else {
          res = await st_api.addTenderToTemplate(tender.tenderId)
        }
        if (res?.success) {
          tender.isTemplate = !tender.isTemplate

          let title = `#${tender.tenderNumber + ' ' + (tender.tenderSubject || tender.title)}`

          this.$notice.info({
            title: title,
            message: this.$t('Common.' + (tender.isTemplate ? 'AddedToTemplates' : 'RemovedFromTemplates'),
              { item: this.$t('Tenders.Tender')}),
            duration: 100
          })
        } else {
          throw this.$t('Errors.STHWrong')
        }
      } catch (error) {
        this.$notice.info({
          title: this.$t('Common.ErrorTitle'),
          message: this.$t('Errors.STHWrong'),
          showClose: true,
          progress: true,
          duration: 10
        })
      }
      return {result: res, isTemplate: tender.isTemplate}
    },
  },
}
